import styled from 'styled-components';

export const ErrorMessageWrapper = styled.div`
  color: #ff0000;
  height: 20px;
`;
